import * as React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import MuiButton from '@mui/material/Button';
import { enqueueSnackbar } from 'notistack';

const ACCEPTED_FILE_TYPES = [
  {
    extension: 'png',
    mimeType: 'image/png',
  },
  {
    extension: 'jpg/jpeg',
    mimeType: 'image/jpeg',
  },
];

const ACCEPTED_MIME_TYPES = ACCEPTED_FILE_TYPES.map(
  fileType => fileType.mimeType
);

type ImageInputProps = {
  setImage: (value: string | null) => void;
  image: string | null;
};

export const ImageInput = (props: ImageInputProps) => {
  const { setImage, image } = props;

  const handleImageUpload: React.ChangeEventHandler<HTMLInputElement> = e => {
    const { files } = e.target;

    const file = files?.[0];
    if (!file) return;

    if (!ACCEPTED_MIME_TYPES.includes(file.type)) {
      enqueueSnackbar('Invalid image file type', {
        variant: 'error',
      });
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.addEventListener('load', () => setImage(reader.result as string));
    // Clear the input value in case the same file is uploaded again after clearing
    e.target.value = '';
  };

  return (
    <Stack direction="column" gap={2}>
      <Typography>
        Image must be in one of the following formats:{' '}
        {ACCEPTED_FILE_TYPES.map(fileType => fileType.extension).join(', ')}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={2}>
        <Stack direction="column" spacing={2}>
          <MuiButton
            component="label"
            variant="contained"
            color="secondary"
            sx={{ textTransform: 'inherit' }}
          >
            Upload
            <input
              hidden
              accept={ACCEPTED_MIME_TYPES.join(', ')}
              type="file"
              onChange={handleImageUpload}
            />
          </MuiButton>
          <Button
            color="error"
            onClick={() => setImage(null)}
            disabled={!image}
          >
            Clear
          </Button>
        </Stack>
        {image ? (
          <img
            style={{ maxWidth: 200, maxHeight: 100 }}
            src={image}
            alt="Upload preview"
          />
        ) : (
          <Box
            width={100}
            height={100}
            border="1px dashed black"
            textAlign="center"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Typography>No image uploaded</Typography>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
